<template>
  <div style="padding-top: 40px">
    <div class="leva-postavitev">
      <p class="navadno-besedilo">
        Na tej strani boste našli tehnične podatke za uvoz elektronske pošte v odjemalce kot so Outlook,
        Thunderbird in drugi.
      </p>
    </div>
    <div class="postavitev-webmail">
      <div class="box-notranja-postavitev-webmail">
        <a class="izpis-sap" :href="povezavaWebmail">
          <b class="blok">
            webmail.t-2.net
          </b>
        </a>
        <p class="navadno-besedilo" style="text-align: center">
          Dostop do pošte preko spleta
        </p>
      </div>
    </div>
    <div style="clear: both"/>
    <div>
      <div style="padding-top: 20px">
        <p class="navadno-besedilo">
          <b>
            Strežnik za prihajajočo pošto
          </b>
        </p>
      </div>
        <el-table
          :data="tableDataPop"
          style="padding-top: 20px"
          stripe
          header-cell-class-name="coloredHeader"
          :span-method="objectSpanMethod"
        >
          <el-table-column prop="server" label="Strežnik za prihajajočo elektronsko pošto"/>
          <el-table-column prop="type" label="Način povezovanja"/>
          <el-table-column prop="port" label="Vrata"/>
        </el-table>

      <div style="padding-top: 20px">
        <p class="navadno-besedilo">
          <b>
            IMAP Nastavitve
          </b>
        </p>
      </div>

        <el-table
          :data="tableDataImap"
          style="padding-top: 20px"
          stripe
          header-cell-class-name="coloredHeader"
          :span-method="objectSpanMethod"
        >
          <el-table-column prop="server" label="Strežnik"/>
          <el-table-column prop="type" label="Način povezovanja"/>
          <el-table-column prop="port" label="Vrata"/>
        </el-table>

      <div style="padding-top: 20px">
        <p class="navadno-besedilo">
          <b>
            Strežnik za odhajajočo pošto
          </b>
        </p>
      </div>

        <el-table
          :data="tableDataSmtp"
          style="padding-top: 20px"
          stripe
          header-cell-class-name="coloredHeader"
          :span-method="objectSpanMethod"
        >
          <el-table-column prop="server" label="Strežnik za odhajajočo elektronsko pošto"/>
          <el-table-column prop="type" label="Način povezovanja"/>
          <el-table-column prop="port" label="Vrata"/>
        </el-table>
    </div>
  </div>
</template>
<script>
  import {povezave} from '../../../../../assets/js/Povezave/povezave'
  import {SmtpEnum} from '../../../../../assets/js/Enum/ElektronskaPostaNastavitve/SmtpEnum'
  import {ImapEnum} from '../../../../../assets/js/Enum/ElektronskaPostaNastavitve/ImapEnum'
  import {PopEnum} from '../../../../../assets/js/Enum/ElektronskaPostaNastavitve/PopEnum'
  import ClientAgent from '../../../../../assets/js/clientAgent.js'

  export default {
    name: 'Nastavitve',
    data () {
      return {
        povezavaWebmail: '',
        tableDataPop: [
          {
            server: 'pop.t-2.net',
            type: 'Nešifrirana povezava z avtentikacijo',
            port: PopEnum.NEDESIFRIRANA_POVEZAVA_Z_AVTENTIKACIJO
          },
          {
            server: '',
            type: 'Šifrirana povezava prek SSL ali TLS protokola',
            port: PopEnum.SIFRIRANA_POVEZAVA_PREK_SSL_ALI_TLS_PROTOKOLA
          },
          {
            server: '',
            type: 'Šifrirana povezava prek STARTLS protokola',
            port: PopEnum.SIFRIRANA_POVEZAVA_PREK_STARTLS_PROTOKOLA
          }
        ],
        tableDataImap: [
          {
            server: 'imap.t-2.net',
            type: 'Nešifrirana povezava z avtentikacijo',
            port: ImapEnum.NEDESIFRIRANA_POVEZAVA_Z_AVTENTIKACIJO
          },
          {
            server: '',
            type: 'Šifrirana povezava prek SSL ali TLS protokola',
            port: ImapEnum.SIFRIRANA_POVEZAVA_PREK_SSL_ALI_TLS_PROTOKOLA
          },
          {
            server: '',
            type: 'Šifrirana povezava prek STARTLS protokola',
            port: ImapEnum.SIFRIRANA_POVEZAVA_PREK_STARTLS_PROTOKOLA
          }
        ],
        tableDataSmtp: [
          {
            server: 'smtp.t-2.net',
            type: 'Šifrirana povezava prek SSL ali TLS protokola',
            port: SmtpEnum.SIFRIRANA_POVEZAVA_PREK_SSL_ALI_TLS_PROTOKOLA
          },
          {
            server: '',
            type: 'Šifrirana povezava prek STARTLS protokola',
            port: SmtpEnum.SIFRIRANA_POVEZAVA_PREK_STARTLS_PROTOKOLA
          }
        ]
      }
    },
    mounted () {
      this.clientAgent = new ClientAgent()
      this.povezavaWebmail = povezave.BASE_URL_WEBMAIL
    },
    methods: {
      objectSpanMethod (data) {
        if (data.columnIndex === 0) {
          if (data.rowIndex % 3 === 0) {
            return {
              rowspan: 3,
              colspan: 1
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0
            }
          }
        }
      }
    }
  }
</script>

<style scoped src="../../../../../../static/css/Nastavitve/Email/NastavitveElektronskaPosta.css"/>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/ElektronskaPosta/Nastavitve.vue